import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getAuth, signInAnonymously } from "firebase/auth";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY as string,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID as string,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET as string,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID as string,
  appId: import.meta.env.VITE_FIREBASE_APP_ID as string,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID as string | undefined,
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// Auth
export const auth = getAuth(app);

// Functions (region must match your function: europe-west1)
export const functions = getFunctions(app, "europe-west1");

// if (import.meta.env.DEV) {
//   console.log("DEV?", import.meta.env.DEV);
//   console.log("Connecting Functions emulator to 127.0.0.1:5005");
//   connectFunctionsEmulator(functions, "127.0.0.1", 5005);
// }